export class DataRetrievalParameters {
  public PageNumber: number;
  public PageSize: number;
  public SortOrder: string;
  public IsDescendingOrder: boolean;
  public Search: string;
}
